<template> 
  <div>
    <main class="container-fluid"> 
      <section class='row'>
        <div class='col-4 px-3 py-3 d-none d-md-flex'></div> 
        <div class='col-24 col-md-11 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5'>
          <div class='col d-column'> 
            <h1 class="title pt-2 mb-0" v-text="$ml.with(username).get('dashTitle')"></h1>
            <h1 class="title"><span v-text="$ml.get('dashSubTitle')" class="pb-2"></span></h1> 
            <div class="card mb-3">
              <div class="card-chart">
                <canvas id="chart-main"/>
              </div>
              <div class="card-body card-chart-body"> 
                <div class="row">
                  <div class="col-6 border-r-d pl-3 mt-2 mb-2">
                    <span class="pb-1" v-text="$ml.get('score')">Pontuação</span>
                    <h6> {{ hacker_score ?? 0 }} </h6>
                  </div>
    
                  <div class="col-6 border-r-d pl-3 mt-2 mb-2">
                    <span class="pb-1" v-text="$ml.get('dashReportResolv')"></span>
                    <h6> {{ amount_of_solved_reports ?? 0 }} </h6>
                  </div>

                  <div class="col-6 border-r-d pl-3 mt-2 mb-2">
                    <span class="pb-1" v-text="$ml.get('programs')">Programas</span>
                    <h6> {{ amount_of_programs ?? 0}} </h6>
                  </div>

                  <div v-if="!received_bounties_brl.length && !received_bounties_usdt.length" class="col-6 pl-3 mt-2 mb-2">
                    <span class="pb-1" v-text="$ml.get('rewardsReceived')">Recompensas recebidas</span>
                    <h6> 0 </h6>            
                  </div> 
                  <div v-else class="col-6 pl-3 mt-2 mb-2">
                    <span class="pb-1" v-text="$ml.get('rewardsReceived')">Recompensas recebidas</span>
                    <h6 v-show="received_bounties_brl.length"> {{ $utils.convertMoney(received_bounties_brl[0]?.total) }} </h6>
                    <h6 v-show="received_bounties_usdt.length"> {{ $utils.convertDollar(received_bounties_usdt[0]?.total) }} </h6>
                  </div> 
                </div>
              </div>
            </div>

            <div class='card mb-3'>
              <div class='card-header' v-text="$ml.get('programsIhaveAlreadyContributed')">
                Programas que já contribuí
              </div>
              <div class='card-body' v-if="listProgram.length">
                <div class='d-column flex-row'  v-for="(item, index) in listProgram" :key="index">
                  <div class='d-flex flex-column pb-3 align-items-start no'>
                    <div :class="'h-profile h-profile-lg d-flex align-self-start flex-column align-items-start w-100 ' + (listProgram.length == index + 1? 'no': '')" >
                      <div class=' d-flex flex-row w-100'> 
                        <div style="width: 75px;">
                          <object width="62" height="62" class="rounded-circle img-lg mr-3" :data="item.program_avatar" type="image/png">
                            <img width="62" height="62" class="rounded-circle img-lg mr-3" src="../../../assets/images/default.png" alt="Avatar">
                          </object>
                        </div>
                        <div class='w-100'>
                          <div class='align-self-start mt-1 w-100'>
                            <h6 class='pb-1'> 
                              <router-link tag="a" :to="'/program/detail?'+item.program_id"   class='link-block'>
                                <strong v-text="item.program_name"></strong>
                              </router-link>  
                            </h6>
                            <p class='d-flex align-items-center'>
                              <span class='align-self-center' v-text="$ml.with($utils.formatData(item.program_createdAt, $ml.get('ln'))).get('publishedDaysAgo')">Publicado há *</span>
                            </p>
                            <hr />
                            <div class='card-chart-body w-100'>

                              <div class='row'>
                                <div class='col-12 border-r-d mb-2'>
                                  <span class='pb-1' v-text="$ml.get('dashReportResolv')">Relatórios aprovados</span>
                                  <h6><a>{{item.reports_amount ?? 0}}</a></h6>
                                </div>
                                <div class='col-12 pl-3 mb-2'>
                                  <span class='pb-1' v-text="$ml.get('rewards')">Recompensas</span> 
                                  <div class="row">
                                    <span class="pr-2 d-flex align-items-center" v-if="item.offers_bounty">
                                      <!-- <img src="../../../../src/assets/icons/dollar-sign.svg" class="ico-13 mr-1"/> -->
                                      <font v-text="$ml.get('money')">Dinheiro</font>
                                    </span>
                                    <span class="d-flex align-items-center" v-if="item.offers_gift">
                                      <img src="../../../../src/assets/icons/gift.svg" class="ico-13 mr-1"/>
                                      <font v-text="$ml.get('gift')">Brinde</font>
                                    </span> 
                                  </div>
                                </div>
                              </div> 
                            </div>
                          </div>
                        </div>
                      </div> 
                    </div> 
                  </div> 
                </div> 
              </div> 
              <div class='card-body' v-else>
                <div class='d-column flex-row'>
                  <div class='d-flex w-100'>
                    <div class='align-self-center loading d-flex mt-1 w-100'>
                      <h6 class='pb-1' v-text="$ml.get('youDontHaveSubmittedReports')">Ainda não possui relatórios enviados!</h6>
                    </div>
                  </div>
                </div> 
              </div> 
            </div> 
          </div> 
        </div>
        <!-- Cards do lado direito, hepl e ranking -->
        <div class="col-24 col-md-5 pr-md-3 py-md-3 px-3 px-md-0">
          <section>
            <Help/>
            <Ranking :title="$ml.get('overallRanking')"/> 
          </section>
        </div>
      </section>
    </main>
  </div> 
</template>

<script>  
import Help from "../../../components/help";
import Ranking from "../../../components/ranking";
import ReportService from "../../../services/report.service";
import Swal from 'sweetalert2' 

import Chart from "chart.js";
import { mapActions } from "vuex";
import accountService from '../../../services/account.service';

export default { 
  components: {  
    Help,
    Ranking
  },
  data() {
    return { 
      title: "Dashboard", 

      username: "",

      hacker_score: 0,
      amount_of_programs: 0, 
      amount_of_solved_reports: 0, 

      received_bounties_usdt: [],
      received_bounties_brl: [],
      listProgram:[],
    };
  },
  created(){

    if(this.$store.getters['getProgramWithout']){ 
      let id = this.$store.getters['getProgramWithout']
      this.setpProgramWithout(''); 
      this.$router.push(`/program/detail?${id}`)
    } 
  },
  mounted() { 
    this.changeChart(); 
    this.changePrograms(); 
    this.username = this.$store.getters['getUser'].username; 
    this.fetchData();
 
  },
  methods: {
    ...mapActions(['setpProgramWithout']),
    changeChart(){
      var self = this;

      var today = new Date();
      var year = today.getFullYear();  

      ReportService.getSpecialistChartData(year).then(
        (response) => { 
          let resp = response.data; 
          this.hacker_score = resp.hacker_score
          this.amount_of_programs = resp.amount_of_programs;  

          this.amount_of_solved_reports = resp.amount_of_solved_reports;   


          this.received_bounties_usdt = resp.received_bounties.filter(it => it.currency === 'USDT')
          this.received_bounties_brl = resp.received_bounties.filter(it => it.currency === 'BRL')
          this.loadChart(resp)
        },
        ({ response }) => {
          if (response.status !== 401) {
            Swal.fire({
            icon: 'info',
            title: '',
            text: self.$ml.get('unableToCompleteThisRequest'),
          }) 
          }

        }
      );
    },
    changePrograms(){ 
      ReportService.getSpecialistPrograms(1,10).then(
        (response) => { 
          this.listProgram = response.data.items 
        }
      );
    },

    loadChart(months){
      var self = this;
      
      var ctx = document.getElementById("chart-main").getContext("2d");
      new Chart(ctx, {
        // The type of chart we want to create
        type: "line",

        // The data for our dataset
        data: {
          labels: [
          this.$ml.get('january'),
            this.$ml.get('february'),
            this.$ml.get('march'),
            this.$ml.get('april'),
            this.$ml.get('may'),
            this.$ml.get('june'),
            this.$ml.get('july'),
            this.$ml.get('august'),
            this.$ml.get('september'),
            this.$ml.get('october'),
            this.$ml.get('november'),
            this.$ml.get('december')
          ],
          datasets: [
            {
              label: self.$ml.get('reportsSent'),
              backgroundColor: "RGBA(115, 11, 169, 0.2)",
              borderColor: "#730BA9",
              data: [ months.jan, months.feb, months.mar, 
                      months.apr, months.may, months.jun, 
                      months.jul, months.aug, months.sep, 
                      months.oct, months.nov, months.dec ],
   
              pointBackgroundColor: [ 
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF", 
              ],
              pointBorderColor: [  
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)", 
              ],
              pointBorderWidth: 1,
              borderWidth: 1,
              pointRadius: 4,
            },
            { 
              backgroundColor: "rgb(255,255,255, 0.3)",
              borderColor: "#ffffff",
  
              data: [12],
            },
          ],
        }, 
        // Configuration options go here
        options: {
          responsive: true,
          maintainAspectRatio: false,
          spanGaps: false,
          layout: {
            padding: {
              left: -4,
              right: 10,
              top: 5,
              bottom: 5,
            },
          },
          elements: {
            line: {
              tension: 0.000001,
            },
            point: {
              radius: 0,
            },
          },
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
                ticks: {
                  beginAtZero: false,
                  display: false,
                },
              },
            ],
            xAxes: [
              {
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
                ticks: {
                  beginAtZero: false,
                  display: false,
                },
              },
            ],
          },
        },
      });
    },
    async fetchData(){
     try {
      const response = await  accountService.getAccountMy();
      const twoFactoryAuthentication = response?.data?.isTwoFactorAuthenticationEnabled;
      this.$store.dispatch('setTwoFactoryAuthenticaton', twoFactoryAuthentication);
     const {language} = response?.data;
     let preferredLanguage = language === "en" ? "english" : language === "es" ? "spanish" : 'portuguese';
     const ln_storage = localStorage.getItem('vueml-lang');
     if(ln_storage != preferredLanguage){
        window.location.reload(true);
        localStorage.setItem('vueml-lang', preferredLanguage) 
     }
     } catch (error) {
      console.log(error)
     }
    },
  },
};
</script>

<style scoped>
  .avatar-wrapper{ 
    height: 62px;
    width: 62px;  
  }
</style>